import { useField } from "formik";
import { cn } from "utils/helpers";
import { DateInput } from "components/DateInput";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";
export const DateSelectionQuestionnaire = ({
	className,
	question,
	required,
	fieldValue,
	...props
}) => {
	const [, { error }] = useField(props);

	return (
		<div className={cn(className)}>
			<BidderQuestionnaireHeader
				question={question}
				required={required}
				error={error}
				touchedField={props?.touchedField}
				description={props?.rfqSubmission ? "Single-date selection" : null}
			/>
			<div>
				<DateInput
					icon={true}
					className="!font-regular flex-3 my-4 !border-fg-disabled_subtle"
					required={required}
					applyFormated={"YYYY-MM-DD"}
					{...props}
				/>
			</div>
		</div>
	);
};
